/** @format */

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//import "./registerServiceWorker";
import "../semantic/dist/semantic.min.css";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.compact.css";

// Import the styles too, typically in App.vue or main.js
import "vue-swatches/dist/vue-swatches.css";
// import "vuetify/dist/vuetify.min.css";
import SuiVue from "semantic-ui-vue";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

//import Vuetify from "vuetify";
import VeeValidate from "vee-validate";
import VueCurrencyInput from "vue-currency-input";

import PlPercentInput from "./components/Generics/PlPercentInput.vue";
const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: "ZAR" },
};
import VueNumeric from "vue-numeric";
import VueNumerals from "vue-numerals";
import PortalVue from "portal-vue";
//import VueParticles from "vue-particles";
import Notifications from "vue-notification";

/*
or for SSR:
import Notifications from 'vue-notification/dist/ssr.js'
*/

Vue.use(Notifications);
//import VueTour from "vue-tour";

//require("vue-tour/dist/vue-tour.css");

//Vue.use(VueTour);
//Vue.use(VueParticles);
//import VueCarousel from "vue-carousel";

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.component("percent-input", PlPercentInput);
Vue.use(VueCurrencyInput, pluginOptions);
//Vue.use(Vuetify);
Vue.use(SuiVue);
Vue.use(VeeValidate);
Vue.use(VueNumeric);
Vue.use(VueNumerals);
Vue.use(PortalVue);
//Vue.use(VueCarousel);

Vue.use(require("vue-moment"));
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
